import { render, staticRenderFns } from "./DocumentTypeList.vue?vue&type=template&id=3a24e08e&scoped=true"
import script from "./DocumentTypeList.vue?vue&type=script&lang=js"
export * from "./DocumentTypeList.vue?vue&type=script&lang=js"
import style0 from "./DocumentTypeList.vue?vue&type=style&index=0&id=3a24e08e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a24e08e",
  null
  
)

export default component.exports